var map = {
	".": "W+Bc",
	"./": "W+Bc",
	"./01_get_account_apiRestrictions": "Xu0+",
	"./01_get_account_apiRestrictions.json": "Xu0+",
	"./index": "W+Bc",
	"./index.js": "W+Bc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pYGg";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/common/api/permission ^.*$
// module id = pYGg
// module chunks = 3